import { Auth } from '../../api';
import { ActionTypes } from '../actions/types';
import { AuthModel } from '../../models/AuthModel';

const initialState: AuthModel = {
  accessToken: localStorage.getItem('token') ?? undefined,
  refreshToken: localStorage.getItem('refreshtoken') ?? undefined,
  backupToken: localStorage.getItem('backuptoken') ?? undefined,
  backupUser: localStorage.getItem('backupUser') ?? undefined,
  username: undefined,
  userID: undefined,
  password: undefined,
  confirmRegistry: undefined,
};

export const updateLocalStorage = (auth: Auth) => {
  if (auth.accessToken) {
    localStorage.setItem('token', auth.accessToken);
  } else {
    localStorage.removeItem('token');
    localStorage.removeItem('backuptoken');
  }

  if (auth.refreshToken) {
    localStorage.setItem('refreshtoken', auth.refreshToken);
  } else {
    localStorage.removeItem('refreshtoken');
  }

  if (auth.username) {
    localStorage.setItem('username', auth.username);
  } else {
    localStorage.removeItem('username');
    localStorage.removeItem('backupUser');
  }

  if (auth.userID) {
    localStorage.setItem('userID', auth.userID);
  } else {
    localStorage.removeItem('userID');
  }
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: Auth }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.SET_AUTHENTICATION: {
      const auth: AuthModel = { ...payload };
      updateLocalStorage(auth);

      return {
        ...state,
        accessToken: auth.accessToken,
        refreshToken: auth.refreshToken,
        username: auth.username,
        userID: auth.userID,
        backupToken: auth.backupToken ?? initialState.backupToken,
      };
    }
    case ActionTypes.SET_CONFIRM_REGISTRY: {
      return {
        ...state,
        confirmRegistry: payload,
      };
    }
    default:
      return state;
  }
}
